<template>
  <div class="q-ml-md q-mt-md">
    <div class="row col-12">
      <div>
        <p
          class="row col-12 items-center justify-between text-h6 text-weight-bold text-brand-5 items-center texto-titulo"
        >
          Relatório de Documentos
          <Modal
            :tipoSelecao="'single'"
            @unidade="getDocumentos"
            :loadingValue="loadingValue"
            :dataDisable="true"
          >
            <template v-slot:conteudo>
              <div class="row col-12 q-px-sm q-mt-sm q-gutter-xs">
                <div class="col">
                  <div class="text-brand-5 text-weight-bold">Nome</div>
                  <q-input
                    dense
                    outlined
                    v-model="filtrosRelatorio.nome"
                    option-label="label"
                    option-value="value"
                  />
                </div>
                <div class="col text-brand-5">
                  <SelecaoCategoriaDocumento
                    @enviarCategoria="receberCategoria"
                    :model="filtrosRelatorio.categoria"
                  />
                </div>
              </div>
              <div class="row col-12 q-px-sm q-mt-sm q-gutter-xs text-brand-5">
                <div class="col">
                  <SelecaoTipoDocumento
                    @enviarTipo="receberTipo"
                    :model="filtrosRelatorio.tipo"
                  />
                </div>
                <div class="col">
                  <div class="text-brand-5 text-weight-bold">Vencimento</div>
                  <q-input
                    class="input"
                    dense
                    outlined
                    placeholder="DD/MM/AAAA"
                    mask="##/##/####"
                    label="Digite a Data"
                    v-model="filtrosRelatorio.dataVencimento"
                    label-color="grey-6"
                  >
                    <template v-slot:append>
                      <q-icon name="event" class="cursor-pointer">
                        <q-popup-proxy
                          cover
                          transition-show="scale"
                          transition-hide="scale"
                        >
                          <q-date
                            :locale="myLocale"
                            v-model="filtrosRelatorio.dataVencimento"
                            mask="DD/MM/YYYY"
                          >
                            <div class="row items-center justify-end">
                              <q-btn
                                v-close-popup
                                label="Fechar"
                                color="primary"
                                flat
                              />
                            </div>
                          </q-date>
                        </q-popup-proxy>
                      </q-icon>
                    </template>
                  </q-input>
                </div>
              </div>
              <div class="row col-12 q-px-sm q-mt-sm q-gutter-xs">
                <div class="col">
                  <div class="text-brand-5 text-weight-bold">
                    Data de Emissão
                  </div>
                  <q-input
                    class="input"
                    dense
                    outlined
                    placeholder="DD/MM/AAAA"
                    v-model="filtrosRelatorio.dataEmissao"
                    mask="##/##/####"
                    label="Digite a Data"
                    label-color="grey-6"
                  >
                    <template v-slot:append>
                      <q-icon name="event" class="cursor-pointer">
                        <q-popup-proxy
                          cover
                          transition-show="scale"
                          transition-hide="scale"
                        >
                          <q-date
                            :locale="myLocale"
                            v-model="filtrosRelatorio.dataEmissao"
                            mask="DD/MM/YYYY"
                          >
                            <div class="row items-center justify-end">
                              <q-btn
                                v-close-popup
                                label="Fechar"
                                color="primary"
                                flat
                              />
                            </div>
                          </q-date>
                        </q-popup-proxy>
                      </q-icon>
                    </template>
                  </q-input>
                </div>
                <div class="col">
                  <div class="text-brand-5 text-weight-bold">
                    Vencimento em Dias
                  </div>
                  <q-input
                    dense
                    outlined
                    type="number"
                    v-model="filtrosRelatorio.vencimentoDias"
                  />
                </div>
              </div>
            </template>
          </Modal>
        </p>
      </div>
    </div>
    <flexmonster
      :exibir="exibir"
      :link="link"
      :columns="slice"
      :slice="slice"
      :exportName="'Documentos'"
      :types="types"
      :grid="layout"
      :updateLink="updateLink"
      :showTotals="showTotals"
      :showGrandTotals="showGrandTotals"
      :filtros="filtros"
      :gerarCsv="gerarCsv"
      :url="url"
      :urlEp="urlEp"
      :formats="formats"
      :dadosRelatorioSalvo="dados"
      :salvarType="'relatorio-documentos'"
      @flexmonsterLoading="loadingStop"
      @enviarRespostaEp="getRelatorioSalvo"
    />
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import SelecaoCategoriaDocumento from "../../documentos/components/SelecaoCategoriaDocumento.vue";
import SelecaoTipoDocumento from "../../documentos/components/SelecaoTipoDocumento.vue";
import Modal from "../components/Modal.vue";

import Flexmonster from "../components/Flexmonster.vue";
export default {
  components: {
    Flexmonster,
    Modal,
    SelecaoCategoriaDocumento,
    SelecaoTipoDocumento,
  },
  setup() {
    const store = useStore();
    const route = useRoute();

    const slice = ref({
      columns: "",
      rows: "",
      reportFilters: "",
      measures: "",
    });
    const link = ref("");
    const layout = ref("flat");
    const loadingValue = ref("");
    const types = ref([]);
    const updateLink = ref(0);
    const exibir = ref(false);
    const id = route.params.id;
    const filtros = ref("");
    const filtrosRelatorio = ref({
      nome: "",
      categoria: "",
      tipo: "",
      dataVencimento: "",
      dataEmissao: "",
      vencimentoDias: "",
    });
    const showTotals = ref("");
    const formats = ref([
      {
        name: "",
        thousandsSeparator: "",
      },
    ]);
    const url = ref("");
    const gerarCsv = ref(false);
    const urlEp = ref("");
    const dados = ref({});
    const showGrandTotals = ref("");
    const relatorioLink = localStorage.getItem("relatorioLink");

    const getDocumentos = async (value, unidade) => {
      try {
        let filtrosObject = {
          unidadeId: unidade?.label,
          nome: filtrosRelatorio.value.nome,
          categoria: filtrosRelatorio.value?.categoria?.uuid,
          tipo: filtrosRelatorio.value?.tipo?.uuid,
          vencimento: filtrosRelatorio.value?.dataVencimento,
          dataEmissao: filtrosRelatorio.value?.dataEmissao,
          vencimentoEmDias: filtrosRelatorio.value.vencimentoDias,
        };
        loadingValue.value = true;
        const response = await store.dispatch("rel/getDocumentos", {
          unidadeId: unidade.id,
          nome: filtrosRelatorio.value.nome,
          categoria: filtrosRelatorio.value?.categoria?.uuid,
          tipo: filtrosRelatorio.value?.tipo?.uuid,
          vencimento: filtrosRelatorio.value?.dataVencimento
            .split("/")
            ?.reverse()
            ?.join("-"),
          dataEmissao: filtrosRelatorio.value?.dataEmissao
            .split("/")
            ?.reverse()
            ?.join("-"),
          vencimentoEmDias: filtrosRelatorio.value.vencimentoDias,
        });

        link.value = response.data.resultado.dados;
        updateLink.value++;
        loadingValue.value = false;
        filtros.value = JSON.stringify(filtrosObject);
        exibir.value = true;
        url.value = response?.request?.responseURL;
      } catch (error) {
        console.log(error);
      }
    };

    const verificarUrl = async () => {
      if (
        id != "carregado" &&
        id != undefined &&
        id != "" &&
        id != "carregadoLink"
      ) {
        try {
          const response = await store.dispatch("rel/listarRelatoriosSalvos", {
            id,
          });
          let value = response.data.resultado.dados.map((e) => {
            e.template = JSON.parse(e.template);
            return e;
          });
          dados.value = value[0];
          urlEp.value = dados.value.url;
          url.value = dados.value.url;
          gerarCsv.value = true;
        } catch (error) {
          console.log(error);
        }
        return;
      }
      if (id == "carregado" && store.state.rel.relatorioCarregado != null) {
        dados.value = store.state.rel.relatorioCarregado;
        console.log(dados.value);
        layout.value = dados.value.layout;
        showTotals.value = dados.value.showTotals;
        showGrandTotals.value = dados.value?.showGrandTotals;

        slice.value.columns = dados.value.columns;
        slice.value.rows = dados.value.rows;
        slice.value.reportFilters = dados.value.filtros;
        slice.value.measures = dados.value.values;

        slice.value?.rows.forEach((e) => {
          e.type = "number";
        });

        const response = await store.dispatch("rel/getCarregado", {
          url: dados.value.url.replace(
            /(?<=\/\/)[^.]+/,
            store.state.autenticacao.cliente[0]
          ),
        });

        link.value = response.data.return.url;
        updateLink.value++;
        loadingValue.value = false;
        url.value = response?.request?.responseURL;
        exibir.value = true;

        return;
      }

      if (
        id == "carregadoLink" &&
        relatorioLink != null &&
        relatorioLink != undefined
      ) {
        exibir.value = true;
        link.value = relatorioLink;
        updateLink.value++;
        url.value = relatorioLink;
        return;
      }
    };

    const getRelatorioSalvo = async (response) => {
      loadingValue.value = true;

      filtros.value = dados.value.filtros;
      layout.value = dados.value.template.layout;
      showTotals.value = dados.value.template.showTotals;
      showGrandTotals.value = dados.value.template?.showGrandTotals;
      link.value = response.resultado.dados;

      slice.value.columns = dados.value.template.columns;
      slice.value.rows = dados.value.template.rows;
      slice.value.reportFilters = dados.value.template.filtros;
      slice.value.measures = dados.value.template.values;
      exibir.value = true;

      slice.value?.rows.forEach((e) => {
        e.type = "number";
      });
      loadingValue.value = false;
    };

    const loadingStop = async (value) => {
      loadingValue.value = value;
    };

    const receberCategoria = (value) => {
      filtrosRelatorio.value.categoria = value;
    };

    const receberTipo = (value) => {
      filtrosRelatorio.value.tipo = value;
    };

    onMounted(() => {
      verificarUrl();
    });

    return {
      getDocumentos,
      slice,
      layout,
      types,
      link,
      updateLink,
      loadingValue,
      exibir,
      filtrosRelatorio,
      getRelatorioSalvo,
      receberCategoria,
      receberTipo,
      id,
      filtros,
      showTotals,
      formats,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      loadingStop,
      verificarUrl,
      url,
      urlEp,
      gerarCsv,
      dados,
      showGrandTotals,
    };
  },
};
</script>
